const { TRIAL_TARIFF_DAYS_DURATION } = require('../appConstants');
const {
    lite2024CommonName,
    professional2024CommonName,
    expert2024CommonName,
    ultimate2025CommonName,
} = require('./common-book-tariffs');

module.exports = {
    ULTIMATE_2025: {
        name: ultimate2025CommonName,
        description: `Idealna opcija ako želite nešto jedinstveno i koristiti Zenamu bez ikakvih ograničenja`,
    },
    EXPERT_2024: {
        name: expert2024CommonName,
        description:
            'Već imam ustaljenu praksu i stalne klijente koji mi se redovito vraćaju. Organiziram više sati tjedno i dugoročne tečajeve s više termina.',
    },
    PROFESSIONAL_2024: {
        name: professional2024CommonName,
        description:
            'Već imam ustaljenu praksu i stalne klijente koji mi se redovito vraćaju. Organiziram više sati tjedno i dugoročne tečajeve s više termina.',
    },
    LITE_2024: {
        name: lite2024CommonName,
        description:
            'Organiziram redovite tjedne satove i povremeno specijalizirane vikend radionice. Moji satovi su namijenjeni redovitim polaznicima.',
    },
    TRIAL_FREELANCER: {
        name: 'Probna verzija s neograničenim funkcijama',
        description: `S novom registracijom dobivate ${TRIAL_TARIFF_DAYS_DURATION} dana neograničenu verziju tarife za samostalne instruktore.`,
    },
    TRIAL_STUDIO: {
        name: 'Probna verzija s neograničenim funkcijama',
        description: `S novom registracijom dobivate ${TRIAL_TARIFF_DAYS_DURATION} dana neograničenu verziju tarife za studije.`,
    },
    FREE: {
        name: 'Početnik',
        description:
            'Držim satove neredovito i više povremeno. Organiziram samo nekoliko sati mjesečno za manju skupinu polaznika.',
    },

    FREELANCER_2024_COMPATIBILITY: {
        name: 'Profesionalac',
        description: 'Ja sam jedan instruktor. Organiziram otvorene satove, tečajeve ili radionice.',
    },
    STUDIO_2024_COMPATIBILITY: {
        name: 'Studio',
        description: 'Organiziramo tečajeve, otvorene satove ili radionice koje vode različiti instruktori.',
    },
    STUDIO_PRO_2024_COMPATIBILITY: {
        name: 'Studio PRO',
        description: 'Organiziramo tečajeve, otvorene satove ili radionice koje vode različiti instruktori.',
    },
};
